import styled from 'styled-components'

export const CommonQuestionsContent = styled.div``
